import React from 'react';
import {Button, Alert} from 'reactstrap';
import ModalComponent from '../../atoms/Modal';

type CopyConfirmModalProps = {
  show: boolean;
  setOpen: (open: boolean) => void;
  itemToCopy: any;
  onConfirm: (item: any) => void;
  type: 'invoice' | 'guide';
};

const CopyConfirmModal: React.FC<CopyConfirmModalProps> = ({ show, setOpen, itemToCopy, onConfirm, type }) => {
  const isInvoice = type === 'invoice';

  // Datos para factura
  const customerName = itemToCopy?.jsonContent?.infoFactura?.razonSocialComprador || 'N/A';
  const invoiceTotal = itemToCopy?.jsonContent?.infoFactura?.importeTotal || '0.00';

  // Datos para guía
  const transporterName = itemToCopy?.transporterName || 'N/A';
  const licensePlate = itemToCopy?.licensePlate || itemToCopy?.jsonContent?.waybillInfo?.licensePlate || 'N/A';

  // Datos comunes
  const sequential = itemToCopy?.sriSequential || itemToCopy?.jsonContent?.infoTributaria?.secuencial || 'N/A';

  const title = isInvoice ? "Copiar Factura" : "Copiar Guía de Remisión";
  const confirmText = isInvoice ? "¿Confirmar copia de factura?" : "¿Confirmar copia de guía de remisión?";
  const description = isInvoice 
    ? "Se cargarán todos los datos de esta factura en el formulario para crear una nueva."
    : "Se cargarán todos los datos de esta guía en el formulario para crear una nueva.";
  const buttonText = isInvoice ? "Copiar Factura" : "Copiar Guía";

  return (
    <ModalComponent
      show={show}
      setOpen={setOpen}
      title={title}
      size="md"
      centered
    >
      <div className="text-center p-3">
        <div className="avatar-md mx-auto mb-4">
          <div className="avatar-title bg-soft-info text-info display-5 rounded-circle">
            <i className="ri-file-copy-2-line"></i>
          </div>
        </div>
        <h4>{confirmText}</h4>
        <p className="text-muted fs-15 mb-4">
          {description}
        </p>

        <Alert color="light" className="border-1 border-dashed p-3 text-start mb-4">
          <div className="d-flex align-items-center mb-2">
            <div className="flex-shrink-0 me-2">
              <i className={`ri-${isInvoice ? 'user' : 'truck'}-line text-primary fs-18`}></i>
            </div>
            <div className="flex-grow-1">
              <h6 className="mb-0 fs-13 text-muted">{isInvoice ? 'Cliente' : 'Transportista'}</h6>
              <span className="fw-semibold text-dark">{isInvoice ? customerName : transporterName}</span>
            </div>
          </div>
          
          <div className="row g-2 mt-1">
            <div className="col-6">
              <div className="d-flex align-items-center">
                <div className="flex-shrink-0 me-2">
                  <i className="ri-hashtag text-primary fs-18"></i>
                </div>
                <div className="flex-grow-1">
                  <h6 className="mb-0 fs-12 text-muted">Secuencial</h6>
                  <span className="fw-medium text-black">{sequential}</span>
                </div>
              </div>
            </div>
            <div className="col-6">
              <div className="d-flex align-items-center">
                <div className="flex-shrink-0 me-2">
                  <i className={`ri-${isInvoice ? 'money-dollar-circle-line' : 'steering-2-line'} text-success fs-18`}></i>
                </div>
                <div className="flex-grow-1">
                  <h6 className="mb-0 fs-12 text-muted">{isInvoice ? 'Total' : 'Placa'}</h6>
                  <span className="fw-medium text-success">
                    {isInvoice ? `$${invoiceTotal}` : licensePlate}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Alert>

        <div className="d-flex gap-2 justify-content-end mt-4">
          <Button 
            color="light"
            onClick={() => setOpen(false)}
            style={{ minWidth: "120px" }}
          >
            Cancelar
          </Button>
          <Button
            color="primary"
            onClick={() => {
              if (itemToCopy) {
                onConfirm(itemToCopy);
              }
              setOpen(false);
            }}
            style={{ minWidth: "120px" }}
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </ModalComponent>
  );
};

export default CopyConfirmModal;
